export const brandName = "Sri Siva Rama Krishna Yoga Center";

export const brandEmail = `tadiboyinasivaramakrishna.yoga@gmail.com`;

export const phoneNumber = +919440618736;

export const address = "Tenali, Andhra Pradhesh, India.";

export const mapsLink = "https://maps.app.goo.gl/QUNfM7txvwUenhPA7";

export const instagram =
  "https://www.instagram.com/srisivaramakrishna.yogacenter/profilecard/?igsh=dDdkNDM4bjRsY3J5";

export const youtube =
  "https://youtube.com/@tadiboyinasivaramakrishna4705?si=doGmpNbfslzoPTYC";

export const facebook = "https://www.facebook.com/share/16ZUxKi4ZW/";

export const onlineSchedule = [
  {
    time: (
      <div>
        <p>Monday</p>
        <p>06:00 AM – 07:00 AM</p>
        <p>04:00 PM – 05:00 PM</p>
        <p>08:30 PM – 09:30 PM</p>
      </div>
    ),
    trainer: "Meera Sharma",
  },
  {
    time: (
      <div>
        <p>Tuesday</p>
        <p>06:00 AM – 07:00 AM</p>
        <p>04:00 PM – 05:00 PM</p>
        <p>08:30 PM – 09:30 PM</p>
      </div>
    ),
    trainer: "Rajiv Nair",
  },
  {
    time: (
      <div>
        <p>Wednesday</p>
        <p>06:00 AM – 07:00 AM</p>
        <p>04:00 PM – 05:00 PM</p>
        <p>08:30 PM – 09:30 PM</p>
      </div>
    ),
    trainer: "Aaradhya Rao",
  },
  {
    time: (
      <div>
        <p>Thursday</p>
        <p>06:00 AM – 07:00 AM</p>
        <p>04:00 PM – 05:00 PM</p>
        <p>08:30 PM – 09:30 PM</p>
      </div>
    ),
    trainer: "Siddharth Joshi",
  },
  {
    time: (
      <div>
        <p>Friday</p>
        <p>06:00 AM – 07:00 AM</p>
        <p>04:00 PM – 05:00 PM</p>
        <p>08:30 PM – 09:30 PM</p>
      </div>
    ),
    trainer: "Ritika Kapoor",
  },
  {
    time: (
      <div>
        <p>Saturday</p>
        <p>06:00 AM – 07:00 AM</p>
        <p>04:00 PM – 05:00 PM</p>
        <p>08:30 PM – 09:30 PM</p>
      </div>
    ),
    trainer: "Ritika Kapoor",
  },
];

export const offlineDays = ["Monday - Saturday"];

export const offlineSchedule = [
  "Morning Classes",
  "07:30 AM – 08:30 AM",
  "08:30 AM – 09:30 AM",
  "10:00 AM – 11:00 AM",
  "11:00 AM – 12:00 PM",
  "Afternoon Classes",
  "03:00 PM – 04:00 PM",
  "05:00 PM – 06:00 PM",
  "06:00 PM – 07:00 PM",
  "07:00 PM – 08:00 PM",
];
